// client/src/utils/merchantPricing.js
// Catalogue partagé des territoires et tarifs pour l'offre commerçant

export const CURRENCY_GROUPS = [
  {
    code: 'EUR',
    label: 'Euro (EUR)',
    territories: [
      { value: 'France (métropole)', label: 'France (métropole)', currencyCode: 'EUR' },
      { value: 'Guadeloupe', label: 'Guadeloupe', currencyCode: 'EUR' },
      { value: 'Martinique', label: 'Martinique', currencyCode: 'EUR' },
      { value: 'Guyane française', label: 'Guyane française', currencyCode: 'EUR' },
      { value: 'La Réunion', label: 'La Réunion', currencyCode: 'EUR' },
      { value: 'Mayotte', label: 'Mayotte', currencyCode: 'EUR' },
      { value: 'Saint-Martin (FR)', label: 'Saint-Martin (FR)', currencyCode: 'EUR' },
      { value: 'Saint-Barthélemy', label: 'Saint-Barthélemy', currencyCode: 'EUR' },
      { value: 'Saint-Pierre-et-Miquelon', label: 'Saint-Pierre-et-Miquelon', currencyCode: 'EUR' },
      { value: 'Allemagne', label: 'Allemagne', currencyCode: 'EUR' },
      { value: 'Autriche', label: 'Autriche', currencyCode: 'EUR' },
      { value: 'Belgique', label: 'Belgique', currencyCode: 'EUR' },
      { value: 'Croatie', label: 'Croatie', currencyCode: 'EUR' },
      { value: 'Chypre', label: 'Chypre', currencyCode: 'EUR' },
      { value: 'Estonie', label: 'Estonie', currencyCode: 'EUR' },
      { value: 'Finlande', label: 'Finlande', currencyCode: 'EUR' },
      { value: 'Grèce', label: 'Grèce', currencyCode: 'EUR' },
      { value: 'Irlande', label: 'Irlande', currencyCode: 'EUR' },
      { value: 'Italie', label: 'Italie', currencyCode: 'EUR' },
      { value: 'Lettonie', label: 'Lettonie', currencyCode: 'EUR' },
      { value: 'Lituanie', label: 'Lituanie', currencyCode: 'EUR' },
      { value: 'Luxembourg', label: 'Luxembourg', currencyCode: 'EUR' },
      { value: 'Malte', label: 'Malte', currencyCode: 'EUR' },
      { value: 'Pays-Bas', label: 'Pays-Bas', currencyCode: 'EUR' },
      { value: 'Portugal', label: 'Portugal (continent)', currencyCode: 'EUR' },
      { value: 'Açores', label: 'Açores (PT)', currencyCode: 'EUR' },
      { value: 'Madère', label: 'Madère (PT)', currencyCode: 'EUR' },
      { value: 'Espagne', label: 'Espagne (péninsule)', currencyCode: 'EUR' },
      { value: 'Îles Canaries', label: 'Îles Canaries (ES)', currencyCode: 'EUR' },
      { value: 'Ceuta', label: 'Ceuta (ES)', currencyCode: 'EUR' },
      { value: 'Melilla', label: 'Melilla (ES)', currencyCode: 'EUR' },
      { value: 'Slovaquie', label: 'Slovaquie', currencyCode: 'EUR' },
      { value: 'Slovénie', label: 'Slovénie', currencyCode: 'EUR' },
      { value: 'Monaco', label: 'Monaco', currencyCode: 'EUR' },
      { value: 'Saint-Marin', label: 'Saint-Marin', currencyCode: 'EUR' },
      { value: 'Vatican', label: 'Vatican', currencyCode: 'EUR' },
      { value: 'Andorre', label: 'Andorre', currencyCode: 'EUR' },
      { value: 'Kosovo', label: 'Kosovo (unilatéral EUR)', currencyCode: 'EUR' },
      { value: 'Monténégro', label: 'Monténégro (unilatéral EUR)', currencyCode: 'EUR' },
      { value: 'Îles Åland', label: 'Îles Åland (FI)', currencyCode: 'EUR' },
    ],
  },
  {
    code: 'USD',
    label: 'Dollar US (USD)',
    territories: [
      { value: 'États-Unis', label: 'États-Unis', currencyCode: 'USD' },
      { value: 'Porto Rico', label: 'Porto Rico (US)', currencyCode: 'USD' },
      { value: 'Îles Vierges américaines', label: "Îles Vierges américaines (US)", currencyCode: 'USD' },
      { value: 'Guam', label: 'Guam (US)', currencyCode: 'USD' },
      { value: 'Samoa américaines', label: 'Samoa américaines (US)', currencyCode: 'USD' },
      { value: 'Îles Mariannes du Nord', label: 'Îles Mariannes du Nord (US)', currencyCode: 'USD' },
      { value: 'Panama', label: 'Panama', currencyCode: 'USD' },
      { value: 'Équateur', label: 'Équateur', currencyCode: 'USD' },
      { value: 'Salvador', label: 'El Salvador', currencyCode: 'USD' },
      { value: 'Timor oriental', label: 'Timor oriental', currencyCode: 'USD' },
      { value: 'Îles Turques-et-Caïques', label: 'Îles Turques-et-Caïques (UK)', currencyCode: 'USD' },
      { value: 'Îles Vierges britanniques', label: 'Îles Vierges britanniques (UK)', currencyCode: 'USD' },
      { value: 'Bonaire, Saint-Eustache et Saba', label: 'Bonaire, Saint-Eustache et Saba (NL)', currencyCode: 'USD' },
      { value: 'Îles Marshall', label: 'Îles Marshall', currencyCode: 'USD' },
      { value: 'Micronésie', label: 'États fédérés de Micronésie', currencyCode: 'USD' },
      { value: 'Palaos', label: 'Palaos', currencyCode: 'USD' },
      { value: 'Sint Maarten (NL)', label: 'Sint Maarten (NL)', currencyCode: 'USD' },
      { value: 'Saint-Barthélemy (USD)', label: 'Saint-Barthélemy (USD)', currencyCode: 'USD' },
      { value: 'Zimbabwe', label: 'Zimbabwe (multi-devises, incl. USD)', currencyCode: 'USD' },
    ],
  },
  { code: 'CAD', label: 'Dollar canadien (CAD)', territories: [{ value: 'Canada', label: 'Canada', currencyCode: 'CAD' }] },
  {
    code: 'GBP', label: 'Livre sterling (GBP)',
    territories: [
      { value: 'Royaume-Uni', label: 'Royaume-Uni (GB)', currencyCode: 'GBP' },
      { value: 'Angleterre', label: 'Angleterre (GB)', currencyCode: 'GBP' },
      { value: 'Écosse', label: 'Écosse (GB)', currencyCode: 'GBP' },
      { value: 'Pays de Galles', label: 'Pays de Galles (GB)', currencyCode: 'GBP' },
      { value: 'Irlande du Nord', label: 'Irlande du Nord', currencyCode: 'GBP' },
      { value: 'Gibraltar', label: 'Gibraltar (GIP, peg GBP)', currencyCode: 'GBP' },
      { value: 'Île de Man', label: 'Île de Man (IMP, peg GBP)', currencyCode: 'GBP' },
      { value: 'Jersey', label: 'Jersey (JEP, peg GBP)', currencyCode: 'GBP' },
      { value: 'Guernesey', label: 'Guernesey (GGP, peg GBP)', currencyCode: 'GBP' },
    ],
  },
  { code: 'CHF', label: 'Franc suisse (CHF)', territories: [{ value: 'Suisse', label: 'Suisse', currencyCode: 'CHF' }, { value: 'Liechtenstein', label: 'Liechtenstein', currencyCode: 'CHF' }] },
  {
    code: 'XOF', label: 'Franc CFA – UEMOA (BCEAO, XOF)',
    territories: [
      { value: 'Bénin', label: 'Bénin (XOF)', currencyCode: 'XOF' },
      { value: 'Burkina Faso', label: 'Burkina Faso (XOF)', currencyCode: 'XOF' },
      { value: "Côte d'Ivoire", label: "Côte d'Ivoire (XOF)", currencyCode: 'XOF' },
      { value: 'Guinée-Bissau', label: 'Guinée-Bissau (XOF)', currencyCode: 'XOF' },
      { value: 'Mali', label: 'Mali (XOF)', currencyCode: 'XOF' },
      { value: 'Niger', label: 'Niger (XOF)', currencyCode: 'XOF' },
      { value: 'Sénégal', label: 'Sénégal (XOF)', currencyCode: 'XOF' },
      { value: 'Togo', label: 'Togo (XOF)', currencyCode: 'XOF' },
    ],
  },
  {
    code: 'XAF', label: 'Franc CFA – CEMAC (BEAC, XAF)',
    territories: [
      { value: 'Cameroun', label: 'Cameroun (XAF)', currencyCode: 'XAF' },
      { value: 'Centrafrique', label: 'République centrafricaine (XAF)', currencyCode: 'XAF' },
      { value: 'Tchad', label: 'Tchad (XAF)', currencyCode: 'XAF' },
      { value: 'Congo (République du)', label: 'Congo (Brazzaville) (XAF)', currencyCode: 'XAF' },
      { value: 'Guinée équatoriale', label: 'Guinée équatoriale (XAF)', currencyCode: 'XAF' },
      { value: 'Gabon', label: 'Gabon (XAF)', currencyCode: 'XAF' },
    ],
  },
];

export const PRICING = {
  EUR: { monthly: 45, annual: 495, currency: '€' },
  USD: { monthly: 45, annual: 495, currency: '$' },
  CAD: { monthly: 70, annual: 770, currency: 'CA$' },
  GBP: { monthly: 45, annual: 495, currency: '£' },
  CHF: { monthly: 45, annual: 495, currency: 'CHF' },
  XOF: { monthly: 5000, annual: 55000, currency: 'CFA' },
  XAF: { monthly: 5000, annual: 55000, currency: 'CFA' },
  DEFAULT: { monthly: 45, annual: 495, currency: '€' },
};
